import { Card } from "../ui/Card.jsx";
import { SectionHeading } from "../ui/SectionHeading.jsx";

export function Team() {
  const founders = [
    { initials: "JL", name: "Jim Liu", role: "CEO" },
    { initials: "DF", name: "Daniel Fernandez", role: "CTO" },
  ];

  return (
    <section className="section section-bg2" id="team">
      <div className="container">
        <SectionHeading
          eyebrow="Who we are"
          title="Operators who have built this before."
          subtitle="Bootstrapped with no outside investment, building on marketing, data, and AI experience from some of the largest consumer platforms."
        />
        <div className="team-grid">
          {founders.map((f) => (
            <Card key={f.initials} className="team-card" data-reveal>
              <div className="team-avatar">{f.initials}</div>
              <h3>{f.name}</h3>
              <div className="team-role">{f.role}</div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
